import Entity from "src/modules/organization/models/Entity";

export default {
  snackbarState: {
    feedbackMessage: 'iets',
    openFeedbackMessage: false,
    feedbackMessageVariant: 'success',
  },
  requests: [],
  subscriptions: [],
  communities: {
    communityOwnerships: [],
    communityMemberships: {
      _page: {
        page: 1,
        pageSize: 25
      },
      items: []
    },
    communityConfigs: null,
    communityStatistics: null,
    communityOwnershipsLoading: false,
    communityManagementMembershipsLoading: false,
    moreCommunityManagementMembershipsLoading: false,
    communityConfigsLoading: false,
    communityStatisticsLoading: false,
  },
  assets: [],
  isLoading: false,
  entity: new Entity(),
};



// WEBPACK FOOTER //
// ./src/modules/core/reducers/initialState.tsx